import { render } from "./BoatEuro.vue?vue&type=template&id=09c32274"
import script from "./BoatEuro.vue?vue&type=script&lang=js"
export * from "./BoatEuro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__